// From https://github.com/aaronpk/pkce-vanilla-js/blob/master/index.html

// Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer
function sha256(plain) {
  const encoder = new TextEncoder()
  const data = encoder.encode(plain)
  return window.crypto.subtle.digest('SHA-256', data)
}

// Base64-url encodes the input string
function base64UrlEncode(buffer: ArrayBuffer) {
  // Convert the ArrayBuffer to string using Uint8 array to convey to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

export async function pkceChallengeFromVerifier(value: string) {
  const hashed = await sha256(value)
  return base64UrlEncode(hashed)
}
